export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: 'AIzaSyBGSv7Zs47X3Pui771Ao0RYqn0aY6nJEkM',
        authDomain: 'gamebit-922fe.firebaseapp.com',
        databaseURL: 'https://gamebit-922fe.firebaseio.com',
        projectId: 'gamebit-922fe',
        storageBucket: 'gamebit-922fe.appspot.com',
        messagingSenderId: '991230546701',
    },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts